import {
    createSuggestFieldComponent,
    ISuggestFieldProperties,
} from '@vfde-brix/suggest-field';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

import { FORM_TEXT_INPUT_BASE_CLASSNAME } from '@vfde-brix/form-text-input';

import { SUGGEST_FIELD_CONTAINER } from '../container/RoamingAdvisor/constants';
import { Clearable } from '../container/RoamingAdvisor/types';

/**
 * mountSuggestField
 * @returns - Clearable
 */
export const mountSuggestField = (countries, changeHandler): Clearable => {
    const data: ISuggestFieldProperties = {
        inputField: {
            containerInput: {
                stdId: 'suggestFieldCountry',
                stdName: 'suggestFieldCountry',
                optType: 'text',
                stdValue: '',
                optAutoCompleteOff: true,
                optSpacingRight: true,
                business: NO_PATTERN_BUSINESS_LOGIC,
            },
            optInputFieldType: FORM_TEXT_INPUT_BASE_CLASSNAME,
            containerLabel: {
                stdFor: '',
                txtText: 'Land',
                business: NO_PATTERN_BUSINESS_LOGIC,
            },
            // Input field business logic (onChange: mandatory, but not in use by suggest field)
            business: {
                onChange: () => {
                    changeHandler();
                },
            },
        },
        business: {
            onSelect: (id, selectedItem) => {
                changeHandler(selectedItem);
                setSuggestFieldValue(selectedItem);
            },
        },
    };

    data.fullResult = countries;
    const element = document.getElementById(SUGGEST_FIELD_CONTAINER);
    const suggestField = createSuggestFieldComponent(element, data);

    (suggestField as any).clear = () => {
        /*
        const input = document.getElementById('suggestFieldCountry') as HTMLInputElement;
        if (input) {
            input.value = '';
        }
        const className = 'brix-input-field__label--filled-out';
        const elem = document.getElementsByClassName('brix-input-field__label--filled-out');
        if (elem.length > 0) {
            elem[0].classList.remove(className);
        }
        */
        setSuggestFieldValue(undefined);
    };

    const setSuggestFieldValue = value => {
        const input = document.getElementById('suggestFieldCountry') as HTMLInputElement;
        const label = input.parentElement.nextElementSibling;
        const className = 'brix-input-field__label--filled-out';

        if (!value) {
            input.value = '';
            label.classList.remove(className);
        }
        else {
            input.value = value;
            label.classList.add(className);
        }
    };

    // TODO: Refactor this code so this should not be necessary
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return suggestField;
};
